import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  style: {"z-index":"1002"},
  class: "flex items-center bg-dark fixed top-0 left-0 w-full h-14 shadow-elevation bg-opacity-90 px-2"
}
const _hoisted_2 = { class: "mr-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lightText" }, "close", -1)
const _hoisted_4 = { class: "text-lightText flex items-center space-x-4" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "ml-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lightText" }, "file_download", -1)
const _hoisted_8 = {
  style: {"z-index":"1001"},
  class: "fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-all-around"
}
const _hoisted_9 = {
  key: 0,
  controls: ""
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "relative"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"650px","height":"350px"},
  class: "bg-gray-600 rounded-sm"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_LinearProgress = _resolveComponent("LinearProgress")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "fixed h-screen w-screen top-0 left-0 bg-dark bg-opacity-60",
      style: {"z-index":"1000"},
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewerClose')))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Btn, {
          class: "mr-2",
          variant: 'icon',
          outline: true,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('viewerClose')))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.filename), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Btn, {
          class: "mr-2",
          loading: _ctx.downloading,
          variant: 'icon',
          outline: true,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('download')))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.videoSrc)
        ? (_openBlock(), _createElementBlock("video", _hoisted_9, [
            _createElementVNode("source", { src: _ctx.videoSrc }, null, 8, _hoisted_10),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("misc.no_native_video_support")), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_LinearProgress, {
              progress: _ctx.downloadProgress,
              class: "absolute top-0 rounded-t-sm"
            }, null, 8, ["progress"]),
            _hoisted_12
          ]))
    ])
  ], 64))
}